import logo from './logo.svg';
import './App.css';
import RouterComponent from './route/route';
import { SnackbarProvider, wrapComponent } from 'react-snackbar-alert';
import {Provider, useDispatch} from 'react-redux';
import {store,persistor} from './redux/store';
import { PersistGate } from 'redux-persist/integration/react'
import { Loader } from './component/Loader';

function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Loader />
        <SnackbarProvider position="top-right">
          <RouterComponent />
        </SnackbarProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
